import { useRouter } from 'next/router';

import { createPaginationLinks } from '@utils';
import { Previous } from './Previous';
import { Next } from './Next';
import { PagerLink } from './PagerLink';

export const Pagination: React.FC<{
  pageCount: number;
  basePath?: string;
}> = ({ pageCount, basePath = '' }) => {
  const router = useRouter();

  if (!pageCount) {
    return null;
  }

  const currentPageNo = parseInt(String(router.query.pageNo)) || 1;
  const queryParams =
    router.query.q === undefined ? '' : `?q=${router.query.q}`;

  const paginationLinks = createPaginationLinks(currentPageNo, pageCount);

  return (
    <div className='my-8 flex items-center justify-center'>
      <Previous
        currentPageNo={currentPageNo}
        postName={basePath}
        params={queryParams}
      />

      <div className='flex gap-1 md:gap-2'>
        {paginationLinks.map((pageNo, index) => {
          return 'number' === typeof pageNo ? (
            <PagerLink
              key={`id-${index}`}
              href={`${basePath}/${
                pageNo > 1 ? `page/${pageNo}/` : ''
              }${queryParams}`}
              isCurrent={pageNo === currentPageNo}
            >
              {pageNo}
            </PagerLink>
          ) : (
            <span key={`id-${index}`} className='py-2'>
              {pageNo}
            </span>
          );
        })}
      </div>
      <Next
        currentPageNo={currentPageNo}
        pageCount={pageCount}
        postName={basePath}
        params={`${queryParams}`}
      />
    </div>
  );
};

export default Pagination;

export { PagerLink };
